import React from 'react'
import { Icon } from './EmptyAvatar.elements'

type Props = {
  className?: string
}

export const EmptyAvatarIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 48 48"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z" fill="#DEE2E5"/>
    <circle cx="24" cy="20" r="8" fill="#B1B7BA"/>
    <path d="M39.563 42.27A23.904 23.904 0 0124 48a23.904 23.904 0 01-15.563-5.73C10.117 35.233 16.447 30 24 30c7.553 0 13.883 5.233 15.563 12.27z" fill="#B1B7BA"/>
  </Icon>
)
